import { render } from "./AdmissionFeeReminderAlert.vue?vue&type=template&id=650d3cc9"
import script from "./AdmissionFeeReminderAlert.vue?vue&type=script&lang=js"
export * from "./AdmissionFeeReminderAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__